import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { CommonService, DocumentsService } from '../../../services/common';
import { DocumentSubType } from '../../../../appconfig';

@Component({
  selector: 'app-user-profile-pic',
  templateUrl: './user-profile-pic.component.html',
  styleUrl: './user-profile-pic.component.scss'
})
/**
 * Cooment by H.K. Gupta
 * This component is made to display user pic. There may be multiple possibilities as follows:
 * 1. Profile pic bytes are comming in Input Field "userData" as "profilePicFile". In this case we will show pic directly
 * 2. Only Profile Pic Record is coming in input field as "profilePicRecord". In this case we will fetch file byte based
 *    on document id of that record
 * 3. Nothing is comming in Input field and just user id is availabe then we will fetch user pic record first and then will
 *    fetch byte on the basis of record. but in this case again there may be multiple possiblilities
 *    3.a. We are getting booking or allotment id in data for which we need to fetch pic as user may have different pic for 
 *         different allotment or booking (due to time interval). In this case we will fetch the particular record of that booking/allotment id
 *     3.b. no booking or allotment id is availabe only user id is available. this will be the case when we looking at client 
 *          profile directly without visitng any particular booking/allotment record. In this case we will fetch lates pic of user
 *          based on his latest booking/allotment
 */


export class UserProfilePicComponent implements OnInit, OnChanges {
  @Input() userData: any;
  userProfileImage: any;
  userProfilePicRecord: any;

  constructor(private commonService: CommonService, private docService: DocumentsService) { }

  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.userData?.userId) {
      this.getUserPIc()
    }
  }

  getUserPIc() {
    //Case 1. when pic byte available in input filed
    if (this.userData?.profilePicFile != null && this.userData?.profilePicFile != undefined) {
      this.userProfileImage = this.userData?.profilePicFile
    }
    else if (this.userData?.profilePicRecord != null && this.userData?.profilePicRecord != undefined) {
      //Case 2 when profilePic record is available but not file byte
      this.getPicFilebyFileId(this.userData?.profilePicRecord?.documentId)
    }
    else {
      this.docService.getFilterDocument(this.userData?.userId, this.userData?.allotmentId, this.userData.bookingId,
        this.userData.projectId, this.userData?.landKhasraId, [DocumentSubType.Photo], null, true).subscribe(res => {
          if (res?.result != null && res?.result != undefined && res?.result?.length > 0) {
            this.userProfilePicRecord = res?.result[0];
            this.getPicFilebyFileId(this.userProfilePicRecord?.documentId)
          }
        })
    }
  }

  getPicFilebyFileId(documentId: any) {
    this.docService.getDocumentBytesById(documentId).subscribe((res: any) => {
      if (res)
        this.userProfileImage = this.commonService.BaseStringToNormalString(res)
    })
  }
}
